module.exports = __webpack_public_path__ + "static/media/1-5.c63209af.svg";